import { parseFiles } from './parser';
import { parseResponse } from './parseResponse';
export function parseUserResponse(cursor, data, cb, person) {
    return parseResponse(cursor, data, parseFiles, cb, person);
}
